import { createSlice } from '@reduxjs/toolkit';

import { fallbackCenterMap } from 'const';
import { SIGNIN } from 'redux/sagas/actions/authentication';

const initialState = { centerMap: fallbackCenterMap };

const setUser = (state, action) => {
  state.user = action.payload.attributes.email;
};

export const appSlice = createSlice({
  name: '@@app',
  initialState,
  reducers: {
    LOADER_OPEN: state => {
      state.isLoading = true;
    },
    LOADER_CLOSE: state => {
      state.isLoading = false;
    },
    SET_CENTER_MAP: (state, action) => {
      state.centerMap = action.payload;
    },
    SET_CONFIG: (state, action) => {
      state.config = action.payload;
    }
  },
  extraReducers: {
    [SIGNIN._SUCCESS]: setUser
  }
});

export const {
  LOCATION_CHANGE,
  LOADER_OPEN,
  LOADER_CLOSE,
  SET_CENTER_MAP,
  SET_CONFIG
} = appSlice.actions;

export default appSlice.reducer;
